export default __webpack_public_path__ + "static/media/thum2.18287b17.jpg";